"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFields = void 0;
var SortFields;
(function (SortFields) {
    SortFields["customerName"] = "customerName";
    SortFields["transaction"] = "transaction";
    SortFields["issueDate"] = "issueDate";
    SortFields["customerPO"] = "customerPO";
    SortFields["amount"] = "grossAmount";
    SortFields["amountdue"] = "netAmount";
    SortFields["dueDate"] = "dueDate";
    SortFields["status"] = "status";
    SortFields["orderNumber"] = "orderNumber";
})(SortFields = exports.SortFields || (exports.SortFields = {}));
